module.exports = __webpack_public_path__ + "img/plane_track_mobile_1.2b6723fa.svg";